import { render, staticRenderFns } from "./socialRate.vue?vue&type=template&id=34d099b9&"
import script from "./socialRate.vue?vue&type=script&lang=js&"
export * from "./socialRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports